module.exports = "/_next/static/images/73d9d4122420500e15c5e140b139c276-roxinho-scene-card-with-phone-xs@3x.jpg";